
import React, { useState, useEffect } from 'react'
import { Button, Form, DatePicker, Spin, Alert } from 'antd'
import axios from 'axios'
import Message from '@beisen-phoenix/message'
import moment from 'moment'
import 'moment/locale/zh-cn'
import locale from 'antd/es/date-picker/locale/zh_CN'
import { getUrlParams } from '../../../utils'
import { DATEFORMAT } from '../../../utils/date-format'
import './index.scss'

moment.locale('zh-cn')

const Accept = () => {
    const [loading, setLoading] = useState(true)//loading
    const [submitLoading, setSubmitLoading] = useState(false)//submitLoading
    const [formDisabled, setFormDisabled] = useState(false)//form是否禁用
    const [isInternshipIdAvailable, setIsInternshipIdAvailable] = useState(true)//链接是否有效
    const [internshipDates, setInternshipDates] = useState([])//可实习日期列表
    const {
        applyId,//申请id
        internshipId,//实习邀请id
        signValue,//MD5校验信息
    } = getUrlParams()

    useEffect(() => {
        //获取可实习日期
        axios.post('/api/jingShun/getInfoIfInternshipIdAvailable', {
            applyId,
            internshipId,
            signValue
        })
            .then(res => {
                const {
                    code,
                    message,
                    data: {
                        isInternshipIdAvailable,
                        internshipDate: internshipDates
                    }
                } = res.data
                if (code === '200') {
                    setIsInternshipIdAvailable(isInternshipIdAvailable)
                    Array.isArray(internshipDates) && setInternshipDates(internshipDates)
                } else {
                    Message.error({ message: message || '服务器异常' })
                }
            }, error => {
                Message.error({ message: error.message });
            }).finally(() => setLoading(false))
    }, [])

    //接受实习邀请
    const onFinish = (values) => {
        setSubmitLoading(true)
        axios.post('/api/jingShun/acceptInternship', {
            applyId,
            internshipId,
            signValue,
            internshipDate: values.internshipDate.format(DATEFORMAT)
        })
            .then(res => {
                const {
                    code,
                    message,
                } = res.data
                if (code === '200') {
                    setFormDisabled(true)
                    Message.success({ message: message || '提交成功' })
                } else {
                    Message.error({ message: message || '服务器异常' })
                }
            }, error => {
                Message.error({ message: error.message })
            }).finally(() => setSubmitLoading(false))
    }
    const disabledDate = (current) => {
        const value = current.format(DATEFORMAT)
        return internshipDates.every(v => v !== value)

    }

    return (
        <Spin spinning={loading}>
            {
                isInternshipIdAvailable ?
                    <div className='accept-internship'>
                        <div className='accept-internship-header'>
                            接受实习
                        </div>
                        <Form
                            disabled={formDisabled}
                            className='accept-internship-body'
                            onFinish={onFinish}
                        >
                            <Form.Item
                                className='internship-date-item'
                                label="实习日期"
                                name="internshipDate"
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择实习日期',
                                    },
                                ]}
                            >
                                <DatePicker className='internship-date' placeholder='请选择实习日期' locale={locale} disabledDate={disabledDate} inputReadOnly={true} />
                            </Form.Item>
                            <Button className='accept-internship-submit' block type="primary" size="large" htmlType="submit" loading={submitLoading}>
                                提交
                            </Button>
                        </Form>
                    </div>
                    :
                    <Alert message='链接已失效' type="warning" showIcon />
            }
        </Spin>
    )
}

export default Accept